import Api from "./base/api-base";

export default class EquipmentApi {
  // 機材マスタ一覧取得
  list() {
    return Api.get({
      endpoint: Api.endpoint.equipment,
    });
  }

  // 機材マスタ登録
  store (params) {
    return Api.post({
      endpoint: Api.endpoint.equipment,
      params: params
    });
  }

  // 機材マスタ情報取得
  info (id) {
    return Api.get({
      endpoint: Api.endpoint.equipment,
      id: id,
    });
  }

  // 機材マスタ更新
  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.equipment,
      id: id,
      params: params
    });
  }

  // 機材マスタ削除
  delete(id) {
    return Api.delete({
      endpoint: Api.endpoint.equipment,
      id: id,
    });
  }
}
